import * as React from "react";
import { Tooltip } from "antd";
import { colors } from "src/constants";
import { SportBetDetail, SportBetLeg } from "src/types/api";

function legSelection(leg: SportBetLeg): string {
  const handicap = leg.handicap && leg.handicap !== "0" ? ` ${leg.handicap}` : "";
  const price = leg.price ? ` @ ${leg.price}` : "";
  return `${leg.selection || "-"}${handicap}${price}`;
}

const subLineStyle: React.CSSProperties = { fontSize: 12, color: colors.cloud7 };
const ellipsisStyle: React.CSSProperties = {
  maxWidth: 260,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

/** Two-line game name of a sport bill; falls back to the wallet game name when the bill detail is missing. */
const SportGameName: React.FunctionComponent<{ gameName?: string; detail?: SportBetDetail | null }> = ({
  gameName,
  detail,
}) => {
  const legs = detail?.legs || [];
  if (!detail || legs.length === 0) return <div>{gameName || "-"}</div>;

  if (detail.betType === "single") {
    const leg = legs[0];
    const title = [detail.sportName || leg.sport, leg.league].filter(Boolean).join(" | ");
    const market = leg.market ? ` · ${leg.market}` : "";
    return (
      <div>
        <Tooltip title={title}>
          <div style={ellipsisStyle}>{title || gameName}</div>
        </Tooltip>
        <div style={subLineStyle}>{`${legSelection(leg)}${market}`}</div>
      </div>
    );
  }

  // A step bill can mix sports, so its header is the leg count instead of a single sport name.
  return (
    <div>
      <div>{`สเต็ป ${legs.length} คู่`}</div>
      {legs.map((leg, index) => (
        <Tooltip key={index} title={[leg.league, leg.market].filter(Boolean).join(" · ")}>
          <div style={{ ...subLineStyle, ...ellipsisStyle }}>
            {`${leg.home || "-"} - ${leg.away || "-"}: ${legSelection(leg)}`}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default SportGameName;
